import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const linkClass = (path: string) =>
    `whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
      location.pathname === path
        ? 'text-primary-600'
        : isScrolled
          ? 'text-foreground-700 hover:text-primary-500'
          : 'text-white/90 hover:text-white'
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer group">
            <span className={`text-xl md:text-2xl font-heading font-semibold tracking-wide transition-colors duration-200 ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              永葆青春
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass('/')}>首页</Link>
            <Link to="/category/kang-shuai-hu-fu" className={linkClass('/category/kang-shuai-hu-fu')}>抗衰护肤</Link>
            <Link to="/category/yin-shi-yang-sheng" className={linkClass('/category/yin-shi-yang-sheng')}>饮食养生</Link>
            <Link to="/category/yun-dong-jian-shen" className={linkClass('/category/yun-dong-jian-shen')}>运动健身</Link>
            <Link to="/category/shui-mian-xiu-fu" className={linkClass('/category/shui-mian-xiu-fu')}>睡眠修复</Link>
            <Link to="/about" className={linkClass('/about')}>关于我们</Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-200 ${
              isScrolled ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-6 py-4 flex flex-col gap-3">
          <Link to="/" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">首页</Link>
          <Link to="/category/kang-shuai-hu-fu" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">抗衰护肤</Link>
          <Link to="/category/yin-shi-yang-sheng" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">饮食养生</Link>
          <Link to="/category/yun-dong-jian-shen" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">运动健身</Link>
          <Link to="/category/shui-mian-xiu-fu" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">睡眠修复</Link>
          <Link to="/about" className="text-foreground-800 text-sm font-medium py-2 cursor-pointer">关于我们</Link>
        </div>
      )}
    </nav>
  );
}